export namespace IProductPageLayoutRequest {
  export enum GridSize {
    GRID_SIZE_UNKNOWN = 'GRID_SIZE_UNKNOWN',
    /**
     * Desktop is default in BE logic.
     */
    DESKTOP = 'DESKTOP',
    /**
     * Mobile-size view will render less tiles.
     */
    MOBILE = 'MOBILE',
  }

  /**
   * Desktop has two layout sessions, part of a collection banner and bottom layout elements
   */
  export enum LayoutSession {
    LAYOUT_SESSION_UNKNOWN = 'LAYOUT_SESSION_UNKNOWN',
    PART_OF_A_COLLECTION = 'PART_OF_A_COLLECTION',
    BOTTOM = 'BOTTOM',
  }

  /**
   * Return an instance of IProductPageLayoutRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IProductPageLayoutRequest>
  ): IProductPageLayoutRequest =>
    ({
      ...(partial ?? {}),
    }) as IProductPageLayoutRequest;
}

export interface IProductPageLayoutRequest {
  product_token: string | undefined;
  /**
   * Deprecated in favor of layoutElementsLimit
   * @deprecated
   */
  grid_size: keyof typeof IProductPageLayoutRequest.GridSize | undefined;
  /**
   * Limits the number of LayoutElement.layoutElementData to return.
   */
  layout_elements_data_limit: number | undefined;
  layout_session:
    | keyof typeof IProductPageLayoutRequest.LayoutSession
    | undefined;
  is_s_d_u_i: boolean | undefined;
  /**
   * @protobufOption (.faire.common.tokenType) = PRODUCT_BASED_COLLECTION
   */
  referring_product_based_collection_token: string | undefined;
  max_results_for_grid: number | undefined;
}
